export const contactData = {
  title: "Contact Us",
  address: "Suite 133, 981 Great West Road, Brentford, TW8 9DN",
  phone: "0208 538 5400",
  email: "info@cygnetcall.co.uk",
  helmet: {
    title: "Contact Us - Cygnet Call Centre",
    description: "Get in touch with Cygnet Call Centre for reliable, efficient, and cost-effective call centre services. Contact us today to learn more.",
    keywords: "Contact Cygnet Call Centre, call centre services, customer support",
    ogTitle: "Contact Us - Cygnet Call Centre",
    ogDescription: "Get in touch with Cygnet Call Centre for reliable, efficient, and cost-effective call centre services. Contact us today to learn more.",
    ogType: "website",
    ogUrl: "https://www.cygnetcall.co.uk/contact",
    ogImage: "https://www.cygnetcall.co.uk/logo.png",
    twitterCard: "summary_large_image",
    twitterTitle: "Contact Us - Cygnet Call Centre",
    twitterDescription: "Get in touch with Cygnet Call Centre for reliable, efficient, and cost-effective call centre services. Contact us today to learn more.",
    twitterImage: "https://www.cygnetcall.co.uk/logo.png"
  }
};

